import { render } from "./field-checkbox.vue?vue&type=template&id=10ebf824"
import script from "./field-checkbox.vue?vue&type=script&lang=js"
export * from "./field-checkbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__